import { styled } from "@octopus-energy/coral-design/jsx"

export const AnimatedNumberContainer = styled("span", {
    base: {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "right",
        fontSize: "5rem",

        md: {
            fontSize: "9rem",
        },
    },
})

export const StyledAnimatedNumber = styled("span", {
    base: {
        fontSize: "6rem",
        md: {
            fontSize: "10rem",
        },
    },
})

export const StyledEuros = styled("span", {
    base: {
        fontSize: "3rem",
    },
})
